import { render, staticRenderFns } from "./VeranstaltungenList.vue?vue&type=template&id=9bbbdb08&scoped=true&"
import script from "./VeranstaltungenList.vue?vue&type=script&lang=js&"
export * from "./VeranstaltungenList.vue?vue&type=script&lang=js&"
import style0 from "./VeranstaltungenList.vue?vue&type=style&index=0&id=9bbbdb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbdb08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
